import { useState } from "react";
import { useModal } from "../../context/ModalContext";
import { ACService } from "../../services/ACService";
import Button from "../Button";
import FormInput from "../FormInput";

import "../styles/ModalSuspended.css";

import fullLogo from "../../assets/images/svg/unicornio-brown.svg";

const SUPPORT_WHATSAPP = String(
  process.env.REACT_APP_CHECKOUT_WHATSAPP_NUMBER || "551152836305",
).replace(/\D/g, "");
const SUPPORT_EMAIL = "contato@purissima.com";
const WAITLIST_TAG = "Lista de Espera - Vendas Suspensas";

const ModalSalesSuspended = () => {
  const { openModal } = useModal();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const isDisabled = loading || !email.trim() || !email.includes("@");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isDisabled) return;
    setLoading(true);
    setFeedback("");
    try {
      await ACService.saveLead("", email.trim(), "", undefined, WAITLIST_TAG);
      setIsSuccess(true);
      setFeedback(
        "Pronto! Você será avisado(a) por e-mail assim que retomarmos.",
      );
      setEmail("");
    } catch (error) {
      setIsSuccess(false);
      setFeedback(
        error.message || "Erro ao registrar seu e-mail. Tente novamente.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ModalSuspended" style={{ backgroundColor: "#E6DDCE" }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-auto mb-3 mb-lg-4">
            <img src={fullLogo} alt="Puríssima" className="logoModalLogin" />
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-12 text-center">
            <h2 className="text-uppercase" style={{ textWrap: "balance" }}>
              <strong>
                A Puríssima está{" "}
                <span style={{ color: "#446D41" }}>temporariamente</span>{" "}
                indisponível para novos pedidos.
              </strong>
            </h2>
            <p className="mt-4 mb-2" style={{ textWrap: "balance" }}>
              Deixe seu e-mail para ser avisado(a) assim que voltarmos.
            </p>

            <form onSubmit={handleSubmit}>
              <FormInput
                required
                float
                type="email"
                name="waitlistEmail"
                label="Seu e-mail"
                placeholder="Informe seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <div className="mt-3">
                <Button
                  type="submit"
                  classes="w-100"
                  disabled={isDisabled}
                  label={loading ? "Enviando..." : "Quero ser avisado"}
                />
              </div>
              {feedback && (
                <div
                  className={`alert p-2 my-3 small ${isSuccess ? "alert-success" : "alert-danger"}`}
                >
                  {feedback}
                </div>
              )}
            </form>

            <hr />

            <h3>
              <strong>Precisa falar com a gente?</strong>
            </h3>
            <div className="mb-4 small d-flex gap-4 justify-content-center flex-column flex-sm-row">
              <a
                style={{ color: "#446D41" }}
                href={`https://wa.me/${SUPPORT_WHATSAPP}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="bi bi-whatsapp"></i> WhatsApp
              </a>
              <a style={{ color: "#446D41" }} href={`mailto:${SUPPORT_EMAIL}`}>
                <i className="bi bi-envelope"></i> {SUPPORT_EMAIL}</a>
            </div>
            <hr />
            <h3>
              <strong>Já é cliente Puríssima?</strong>
            </h3>
            <Button
              classes="mx-auto"
              onClick={() => openModal("modalLogin")}
              label="Acessar minha conta"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalSalesSuspended;
